import React, { useState,useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter,
	InputGroup,
    InputGroupText,Row,Col } from 'reactstrap';
import { Formik, Field } from 'formik';
import FormikInputField from 'components/common/Fields/FormikInputField';
import * as Yup from 'yup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faClose } from '@fortawesome/free-solid-svg-icons';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import FormikDatePicker from 'components/common/Fields/FormikDatePicker';
import Calendar from 'assets/icon/calendar-icon.svg';
import { dateFormate } from 'utils/columns';
import { cloneDeep, find } from 'lodash';
import { toast } from 'react-toastify';
import Confirm from 'components/Confirm';
import useAxios from 'hooks/useAxios';
import HoverImage from 'react-hover-image/build';
import SaveIcon from "assets/icon/icon-icon-options-order-complete.svg";
import SaveHoverIcon from "assets/icon/icon-icon-options-order-complete-hover.svg";
import save from "assets/icon/save.svg";
import Cancel from "assets/icon/CancelIcon-manufacture.svg";
import CancelIcons from "assets/icon/CancelIcons.svg";
import DeleteIcon from "assets/icon/icon-icon-options-delete.svg";
import DeleteHoverIcon from "assets/icon/icon-icon-options-delete-hover.svg";

// const initialValues = {
// 	ndc: '',
// 	ndcDescription: '',
// 	packageSize: '',
// 	adjustmentDate: '',
// 	packages: '',
// 	comment: '',
// 	users: ''
// };

const validationSchema = Yup.object({
	// packageSize: Yup.string().required('Required'),
	adjustmentDate: Yup.string().required('Required'),
	packages: Yup.string().required('Required'),
	comment: Yup.string().required('Required')
});

let hasDatePopupOpen = false;
// const AddModal = ({ isOpen,rowData,tenantID, toggle ,addFlag,addData,refetch , packageSize,backUpData  , dynamicData , setDynamicData , setHasToRest , hasToRest }) => {
const AddModal = ({ isOpen,rowData,tenantID, toggle ,addFlag,addData,refetch , packageSize  ,  setHasToRest   }) => {
	const API = useAxios();
	const [isConfirm, setConfirm] = useState(false);
	const [loading, setLoading] = useState(false);
	const [adjustmentDate, setAdjustmentDate] = useState('');
	const [packages,setPackages]=useState();
	// const [packageSize,setPackageSize]=useState();	
	const [comment,setComment]=useState();
    const [hideRow, setHideRow] = useState(false);
    const [resultData, setResultData] = useState([]);	
    const [showResultRow, setShowResultRow] = useState(true);
    const [adjustmentList, setAdjustmentList] = useState([]);
	const [ state, updateState ] = useState({
		initialValues : {
			ndc: '',
			ndcDescription: '',
			packageSize: '',
			adjustmentDate: '',
			packages: '',
			comment: '',
			users: ''
		},
		rows: []
	});
// 	useEffect(() => {
// 		if(editData == undefined)
// 		setState({
// 			initialValues: {
// 				packageSize :''
// 			}
// 		});
//   if(editData && editFlag == true)
// 	setState({
// 		initialValues: {
// 			packageSize : editData.packageSize
// 		}
// 	});
	
//     }, [editData]);
	const setState = (obj) => updateState((pre) => ({ ...pre, ...obj }));

	const handleSubmit = (val, actions) => {	
		const { resetForm, setSubmitting } = actions;
        var lst = {};
		lst.NDC=rowData.ndc;
		lst.DrugDescription = rowData.drugName;
		lst.PackageSize=packageSize;
		lst.AdjustmentDate=adjustmentDate;
		lst.Packages=packages;
        lst.Comments = comment;
		lst.ContractID=rowData.contractID;
        if (adjustmentList.length > 0) {
            let cCheck = adjustmentList.filter(m => m.PackageSize == lst.PackageSize && m.AdjustmentDate == lst.AdjustmentDate && m.Packages == lst.Packages);
            if (cCheck.length == 0) {
                setAdjustmentList(old => [...old, lst]);
            }
            else {
                toast.error('Duplicate entry not allowed.');
            }
        }
        else {
            setAdjustmentList(old => [...old, lst]);
        }
		handleReset();		
		resetForm();
		setSubmitting(false);
	};
	const handleReset = () => {
        setComment();
     initialValues.packageSize = '';
		setPackages();
		setAdjustmentDate('');
    };

	const handletoggle=()=>{
		handleReset();		
		setAdjustmentList([]);
		setResultData([]);
		setHideRow(false);
		setShowResultRow(true);
		toggle();
	}

	const { rows,initialValues } = state;

	const onHandleDelete = (id) => {
		const updatedRows = rows.filter((item) => item.id !== id);
		setState({
			rows: updatedRows
		});
	};
	const handleStartDate = (setFieldValue,startDate) => {
        let stDate = dateFormate(startDate);
        setAdjustmentDate(stDate);
		
		setFieldValue('adjustmentDate', startDate);
    };

	const handleDateClick = (id) => {
        if (hasDatePopupOpen) {
            hasDatePopupOpen = false;
            return;
        }
        const calendarButton = document.getElementById(id);
        if (calendarButton) {
            calendarButton.click();
            hasDatePopupOpen = true;
        }
    };

    const handleMouseLeave = () => {
        hasDatePopupOpen = false;
    };
	const handlePacOnChange = ({ target: { value } }) => {
		setPackages(value)
	  };
	  const handlePacSizeOnChange = ({ target: { value } }) => {
		setState({
			initialValues: {
				packageSize :value
			}
		});
	  };
	  const handleCommentOnChange = ({ target: { value } }) => {
		setComment(value)
	  };
	  let saveDisabled = (adjustmentList.length > 0) ? false : true;
	const handleSaveConfirmation = () => {
        setConfirm(!isConfirm);
    };
	const handleAdjustmentSubmit = async () => {
        handleSaveConfirmation();
        setLoading(true);
        let payload = {};
        payload = adjustmentList;
		if(addFlag == true){
			payload = adjustmentList;
			payload[0].Id = addData.id;
			try {
				const result = await API.post(
					`/${tenantID}/Inventory/Updateadjustments`,
					payload);
			
				if (result?.data) {
					toast.success('Adjustment Update successfully');
					handletoggle();
					setResultData(old => ([...old,...result.data]));
					// setHideRow(true);
					console.log(resultData);
					// setShowResultRow(false);
					setLoading(false);
					refetch(true);
				}

			}
			catch (error) {
				console.log(error);
				setLoading(false);
			}
		}
		else{
			try {
				const result = await API.post(
					`/${tenantID}/Inventory/AddAdjustments`,
					payload);
				toast.success('Adjustment saved successfully');
				handletoggle();
			
				if (result?.data?.length > 0) {
					setResultData(old => ([...old,...result.data]));
					// setHideRow(true);
					console.log(resultData);
					// setShowResultRow(false);
					setLoading(false);
					refetch(true);
					setHasToRest(true) ;
				}
			} catch (error) {
				console.log(error);
				setLoading(false);
			}
		}
        setLoading(false);
    }

	const handleDeleteConfirmation = async (item) => {
		let cCheck = adjustmentList.filter(m => !(m.PackageSize == item.PackageSize && m.AdjustmentDate == item.AdjustmentDate && m.Packages == item.Packages));
		setAdjustmentList(cCheck);
	};

	return (
		<div>
			<Modal isOpen={isOpen} toggle={handletoggle} size="xxl">
				<ModalHeader toggle={handletoggle}>{ "ADD ADJUSTMENTS"}</ModalHeader>
				<ModalBody style={{ minHeight: 200 }}>
					<Row hidden={hideRow}>
						<div className="table-card">
						<table className="theme-table table table-striped border-0 w-100">
							<thead>
								<tr>
									<th>NDC</th>
									<th>NDC Description</th>
									<th>Adjustment date</th>
									<th>Packages</th>
									<th className="w-20">Comments</th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								<Formik
									onSubmit={handleSubmit}
									initialValues={initialValues}
									validationSchema={validationSchema}
									enableReinitialize={true}
									children={(props) => {
										const { isSubmitting, handleSubmit, setSubmitting,setFieldValue } = props;
										return (
											<tr>
												<td>
												<span className="m-0 f-14 font-weight-500">{rowData?.ndc ||'-'}</span>
												</td>
												<td>
												<span className="m-0 f-14 font-weight-500">{rowData?.drugName || '-'}</span>
												</td>
												<td>
													<InputGroup onMouseLeave={handleMouseLeave}>
														<Field
															type='text'
															id='adjustmentDate'
															name='adjustmentDate'
															className='form-field-large inner-shadow-field required'
															autoComplete='off'
															placeholder= { "Select a date"}
															value={adjustmentDate}
															component={FormikDatePicker}
															onChange={(value)=>handleStartDate(setFieldValue,value)}
															onKeyDown={(e) => {
																e.preventDefault();
															}}
														/>
														<InputGroupText
															onClick={() => handleDateClick('adjustmentDate')}
														>
															<img src={Calendar} alt='' />
														</InputGroupText>
													</InputGroup>
												</td>
												<td>
													<Field
													id='packages'
													name='packages'
													className='required'
													type='number'
													placeholder={"Enter Packages"}
													autoComplete='off'
													value={packages}
													component={FormikInputField}
													onKeyUp={handlePacOnChange}
												/>
												</td>
												<td>
													<Field
														id="comment"
														name="comment"
														className='required'
														type="textarea"
														autoComplete="off"
														placeholder= { "Enter Comments" }
														rows={1}
														value={comment}
														component={FormikInputField}
														onKeyUp={handleCommentOnChange}
													/>
												</td>
												<td>
													<Button
														disabled={isSubmitting}
														onClick={handleSubmit}
														type="submit"
														color="link"
														hidden={addFlag == true}
													>
														<FontAwesomeIcon
															icon={faPlusCircle}
															className="text-primary f-22"
														/>
													</Button>
													
												</td>
											</tr>
										);
									}}
								/>
								{
									adjustmentList.map((item, index) => (
										<tr key={item.NDC}>
											<td>{item.NDC}</td>
											<td>{item.DrugDescription}</td>
											<td>{dateFormate(item.AdjustmentDate)}</td>
											<td>{item.Packages}</td>
											<td>{item.Comments}</td>
											<td>
												<Button
													className="text-primary p-0 text-decoration-none d-flex m-auto"
													color="link"
													onClick={() => handleDeleteConfirmation(item)}
													title="Delete"
												>
													<HoverImage src={DeleteIcon} hoverSrc={DeleteHoverIcon} alt="" />
												</Button>

											</td>
										</tr>
									))
								}
							</tbody>
						</table>
					</div>

					</Row>

					{/* <Row >
					<div className="table-card">
						<table className="theme-table table table-striped border-0 w-100">
							<thead>
								<tr>
									<th>Status</th>
									<th>Message</th>
									<th>NDC</th>
									<th>NDC Description</th>
									<th>Adjustment date</th>
									<th>Packages</th>
									<th className="w-20">Comments</th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								{
									resultData.map((item, index) => (
										<tr key={item.ndc}>
											<td>
												{item.success == true && "Success"}
												{item.success == false && "Duplicate Contract"}
											</td>
											<td>{item.message}</td>
											<td>{item.ndc}</td>
											<td>{item.drugDescription}</td>
											<td>{dateFormate(item.adjustmentDate)}</td>
											<td>{item.packages}</td>
											<td>{item.comments}</td>
										</tr>
									))
								}
							</tbody>
						</table>
					</div>

					</Row> */}
					
				</ModalBody>
				<ModalFooter>
					<Button className="reset" color="cancel" outline onClick={handletoggle}>
						            <span className="right_5">
              <img src={Cancel} alt="" />
            </span>{" "}
						Cancel
					</Button>{' '}
					<Button color="primary" className='search' disabled={saveDisabled} onClick={handleSaveConfirmation}>
						 <span className="right_5">
                          <img src={save} alt="" />
                        </span>{" "}
						Save
					</Button>
				</ModalFooter>
			</Modal>
			<Confirm
                isOpen={isConfirm}
                loading={loading}
                message='Are you sure you want to save?'
                onToggle={handleSaveConfirmation}
                onCancel={handleSaveConfirmation}
                onContinue={handleAdjustmentSubmit}
            />
		</div>
	);
};

export default AddModal;
